
import * as React from 'react';
//import logo from '../../images/LogoBusinessReportsTrans.png';
//import logo from '../../images/milogo.jpg';
import { Router, Route, Link } from 'react-router-dom';
import { SidebarComponent } from '@syncfusion/ej2-react-navigations';
import { MenuComponent } from '@syncfusion/ej2-react-navigations';
import { SampleBase } from '../../syncfusion/sample-base';
import './sideBarMenu.css';
import { PivotTableToolBar } from '../pivotTableToolBar/pivotTableToolBar'
import { pivotSettings } from '../pivotTableToolBar/pivotTableDataSettings'
import { LoginPage } from '../loginPage/LoginPage'
import { authenticationService } from '../../_services';
import HomePage from '../homePage/homePage'
import { history } from '../../_helpers'; 
import { userProfile, userProfileAll } from '../userProfile'
import { mttoLote } from '../agroApp'
import Map from '../maps/heatMaps'
import { OXIDashboard } from '../dashBoard/dashBoardOxi'
import { SEODashboard } from '../dashBoard/dashBoard'
import { PrivateRoute, PrivateRouteRender } from '../privateRoute/PrivateRoute'
import { /* config, */handleResponse } from '../../_helpers'
import { ganttEditing, gridTable, MasterDetail } from '../proyectos'


let pivotDataSettings = pivotSettings;
let localeUser;
let localMenuUser;

export class SidebarWithMenu extends SampleBase {
    constructor() {
        super(...arguments);

        this.state = {
            currentUser: null,
            userData: {},
            userGroup: {},
            userLanguage: {}
        };
 
        this.config = window.config;
        this.mediaQuery = '(min-width: 600px)';
        this.enableDock = true;
        this.dockSize = '45px';
        this.width = '150px';
        this.target = '.main-content';
        this.node = document.createElement('ChartIntegration');                 // Create a <li> node
    }

    async loadReportDB() {
    
        const name = 'saveReport';
        const user = authenticationService.currentUserValue.usuario.email;

        var raw = JSON.stringify({ name, user });
    
        var requestOptions = { 
            method: 'POST',
            //mode: 'no-cors',
            headers: { "Content-Type": "application/json",
                        "api-token": `${authenticationService.currentUserValue.jwt_token}`   },
            body: raw,
            redirect: 'follow'
        };
    
        //console.log(localStorage.config)  Cambio de this a session
        const respuesta = await fetch( JSON.parse(sessionStorage.config).HostUrlAuth+"reports/findxus", requestOptions)
            .then(handleResponse)
            .then(resp => {
                debugger;
                //var i=0;
                var repMod = []
                var itemMod = {};
                // eslint-disable-next-line
                resp.map(function (item) {
                    /* repMod.report = item.report;
                    repMod.option = item.option;
                    repMod.user = item.user;
                    repMod.reporName = */
                    itemMod = {report:item.report,
                                option: item.option,
                                user: item.user,
                                reportName: item.reportname,
                                name: item.name};
                    repMod.push(itemMod);
                });
                localStorage.pivotviewReports = JSON.stringify(repMod);
                return JSON.stringify(repMod);
            })
            .catch(err => {
                debugger;
                //alert("Error de conexion, verifique el tiempo de duraccion del token.");
                Promise.reject('Error de consulta');
                //authenticationService.logout();
             } );
        
        //console.log('respuesta');
        //console.log(JSON.parse(respuesta));
    
        //this.pivotObj.refresh();
        return respuesta;
    }

     componentDidMount() {
        authenticationService.currentUser.subscribe(x => this.setState({ currentUser: x }));
    }

    logout() {
        authenticationService.logout();
        this.props.history.push('/login');
    }

    configSettings() {
        const { currentUser } = this.state;


        if (currentUser) {
            //debugger;
            localeUser=authenticationService.currentUserValue.usuario.idioma;
            localMenuUser = JSON.parse(authenticationService.currentUserValue.usuario.menu.replace(/'/g,"\""));
            this.menuItems = localMenuUser[localeUser].principal;
            this.AccountMenuItem = localMenuUser[localeUser].menucuenta;
            this.supportOption = localMenuUser[localeUser].supportOption
        }
      
    }

    render() {
        const { currentUser } = this.state;
        debugger;
        console.log('configuracion :')
        console.log(sessionStorage.config)
       /*  if (this.config.HostUrlAuth) {
            localStorage.setItem('config', JSON.stringify(this.config));
        } */
        if (!currentUser) {
            //history.push('/');
            authenticationService.currentUser.subscribe(x => this.setState({ currentUser: x }));
            //const { currentUser } = this.state.currentUser;
            /* if (!this.config) {
                this.config = {HostUrl:sessionStorage.config.HostUrl,
                                HostUrlAuth:sessionStorage.config.HostUrlAuth,
                                HostEndUrl:sessionStorage.config.HostEndUrl};
            } */
              
        }
        
        this.configSettings();
        if (currentUser) {
            this.loadReportDB();
        }
        var logoxx = require('../../images/tulogo.jpg')
        return (
            <Router history={history}>
                <div className="control-section sidebar-menu">
               
                <div id="wrapper">
                    <title>CSIBS Reports Sidebar </title>
                    {currentUser && 
                        <div className="col-lg-12 col-sm-12 col-md-12">
                        
                        <div className="header-section dock-menu" id="header">
                            <ul className="header-list">
                                <li id="hamburger" className="icon-menu icon list" onClick={this.openClick.bind(this)}></li>
                                <a  title="CSI Business Services" href="http://www.csibs.com.co" target="_blank" rel="noopener noreferrer"><img src={logoxx} className="App-logo" alt="CSI Business Services"/></a>
                                <li className="right-header list">
                                    <div className="horizontal-menu">
                                        
                                        <MenuComponent items={this.AccountMenuItem} cssClass='dock-menu1' id='MenuRigth' > </MenuComponent>

                                    </div>
                                </li>
                                <a className="right-header list support" href="mailto:soporte@csibs.com.co">{this.supportOption}</a> 
                                {/* <a onClick={this.logout} className="right-header list support">Logout</a> */}
                            </ul>
                        </div>
                        
                        <SidebarComponent id="sidebar-menu" ref={Sidebar => this.sidebarobj = Sidebar} enableDock={this.enableDock} mediaQuery={this.mediaQuery} dockSize={this.dockSize} width={this.width} target={this.target} >
                            <div className="main-menu">
                                <p className="main-menu-header">  </p>
                                <MenuComponent ref={Menu => this.menuobj = Menu} items={this.menuItems} orientation='Vertical' cssClass='dock-menu' select={this.onSelect.bind(this)} 
                                    template={this.menuTemplate}></MenuComponent> 
                                {/* <Link to="/prueba" className="nav-item nav-link">Prueba</Link> */}
                            </div>
                        </SidebarComponent> 
                        </div>
                        }
                        <div className="main-content" id="maintext">
                            <div className="sidebar-menu-content">
                                <div className="main-content textArea"> 
                              
                                    <PrivateRoute exact path="/" component={HomePage} />
                                    <PrivateRouteRender path="/ventas"  component={PivotTableToolBar} pv_id='PivotViewVentas' pts_id='pivot-table-section-ventas' dataSourceSettings={pivotDataSettings.ventas} opcion='ventas'  arch_json={true} />
                                    <PrivateRouteRender path="/oxipro/ordenes"  component={PivotTableToolBar} pv_id='PivotViewOrdenes' pts_id='pivot-table-section-ordenes' dataSourceSettings={pivotDataSettings.ordenes} opcion='ordenes' />
                                    <PrivateRouteRender path="/oxipro/ordenescsv"  component={PivotTableToolBar} pv_id='PivotViewOrdenes' pts_id='pivot-table-section-ordenes' dataSourceSettings={pivotDataSettings.ordenes} opcion='ordenes' arch_csv={true} />
                                    <PrivateRouteRender path="/oxipro/valorvisita"  component={PivotTableToolBar} pv_id='PivotViewValorVisita' pts_id='pivot-table-section-visita' dataSourceSettings={pivotDataSettings.v_valor_visita} opcion='v_valor_visita' />
                                    <PrivateRouteRender path="/oxipro/contable"  component={PivotTableToolBar} pv_id='PivotViewValorOxiContable' pts_id='pivot-table-section-oxicontable' dataSourceSettings={pivotDataSettings.oxicontable} opcion='oxicontable' />
                                    <PrivateRouteRender path="/oxipro/dashboard1"  component={OXIDashboard} datos={pivotDataSettings.oxipro} opcion='oxidash1'/>
                                    <PrivateRouteRender path="/agroapp/cosecha"  component={PivotTableToolBar} pv_id='PivotViewAgro' pts_id='pivot-table-section-agro' dataSourceSettings={pivotDataSettings.agro} opcion='agro'  arch_json={true} />
                                    <PrivateRouteRender path="/agroapp/lote" component={mttoLote} opcion='mttolote'/> 
                                    {/* <PrivateRouteRender path="/agroapp/agrolote" component={gridTable} opcion='lote'/>  */}
                                    <PrivateRouteRender path="/agroapp/dashboard1"  component={SEODashboard} datos={pivotDataSettings.agro} opcion='agrodash1'/>
                                    <PrivateRouteRender path="/agroapp/heatMap"  component={Map}/>
                                    <PrivateRouteRender path="/simetria"  component={PivotTableToolBar} pv_id='PivotViewSimetria' pts_id='pivot-table-section-simetria' dataSourceSettings={pivotDataSettings.simetria} opcion='simetria'  arch_json={true} />
                                    <PrivateRouteRender path="/consultas"  component={PivotTableToolBar} pv_id='PivotViewConsExt' pts_id='pivot-table-section-consext' dataSourceSettings={pivotDataSettings.consultas} opcion='consultas'  />
                                    <PrivateRouteRender path="/hospitalizacion" component={PivotTableToolBar} pv_id='PivotViewHospital' pts_id='pivot-table-section-hospital' dataSourceSettings={pivotDataSettings.hospitalizacion}  opcion='hospitalizacion' />
                                    <PrivateRouteRender path="/medicamentos"  component={PivotTableToolBar} pv_id='PivotViewMedica' pts_id='pivot-table-section-medica' dataSourceSettings={pivotDataSettings.medicamentos}  opcion='medicamentos' />
                                    <PrivateRouteRender path="/servicios"  component={PivotTableToolBar} pv_id='PivotViewsalotrosserv' pts_id='pivot-table-section-salotrosserv' dataSourceSettings={pivotDataSettings.servicios} opcion='servicios'  arch_json={false}  />
                                    <PrivateRouteRender path="/procedimientos"  component={PivotTableToolBar} pv_id='PivotVieproced' pts_id='pivot-table-section-proced' dataSourceSettings={pivotDataSettings.procedimientos} opcion='procedimientos' />
                                    <PrivateRouteRender path="/urgencias"  component={PivotTableToolBar} pv_id='PivotViewUrgencias' pts_id='pivot-table-section-urgencias' dataSourceSettings={pivotDataSettings.urgencias} opcion='urgencias' />
                                    <PrivateRouteRender path="/facturacion"  component={PivotTableToolBar} pv_id='PivotViewFacturacion' pts_id='pivot-table-section-facturacion' dataSourceSettings={pivotDataSettings.facturacion} opcion='facturacion' />
                                    <PrivateRouteRender path="/ick"  component={PivotTableToolBar} pv_id='PivotViewIck' pts_id='pivot-table-section-ick' dataSourceSettings={pivotDataSettings.ick} opcion='ick'  arch_json={true}/>
                                    <PrivateRouteRender path="/iri"  component={PivotTableToolBar} pv_id='PivotViewIri' pts_id='pivot-table-section-iri' dataSourceSettings={pivotDataSettings.iri} opcion='iri'  arch_json={true}/>
                                    <PrivateRouteRender path="/icd"  component={PivotTableToolBar} pv_id='PivotViewIcd' pts_id='pivot-table-section-icd' dataSourceSettings={pivotDataSettings.icd} opcion='icd'  arch_json={true}/>
                                    <PrivateRouteRender path="/dpv"  component={PivotTableToolBar} pv_id='PivotViewDpv' pts_id='pivot-table-section-dpv' dataSourceSettings={pivotDataSettings.dpv} opcion='dpv'  arch_json={true}/>
                                    <PrivateRouteRender path="/isv"  component={PivotTableToolBar} pv_id='PivotViewIsv' pts_id='pivot-table-section-isv' dataSourceSettings={pivotDataSettings.isv} opcion='isv'  arch_json={true}/>
                                    <PrivateRouteRender path="/contable"  component={PivotTableToolBar} pv_id='PivotViewContable' pts_id='pivot-table-section-contable' dataSourceSettings={pivotDataSettings.contable} opcion='contable'  arch_json={true}/>
                                    <PrivateRouteRender path="/users" component={userProfileAll} /> 
                                    <PrivateRouteRender path="/proyectos/gantt" component={ganttEditing} /> 
                                    <PrivateRouteRender path="/proyectos/clientes" component={gridTable} opcion='clientes'/> 
                                    <PrivateRouteRender path="/proyectos/paises" component={gridTable} opcion='paises'/> 
                                    <PrivateRouteRender path="/proyectos/proyectos" component={gridTable} opcion='proyectos'/> 
                                    <PrivateRouteRender path="/proyectos/proyectomaestro" component={MasterDetail} opcion='proyectomaestro'/> 
                                    {/* <PrivateRouteRender path="/proyectos/usuarios_proyecto" component={gridTable} opcion='usuarios_proyecto'/>  */}
                                    <PrivateRouteRender path="/proyectos/recursos" component={gridTable} opcion='recursos'/> 
                                    <PrivateRouteRender path="/proyectos/recursos_proyecto" component={gridTable} opcion='recursos_proyecto'/> 
                                    <PrivateRouteRender path="/proyectos/marcadores" component={gridTable} opcion='marcadores'/> 
                                    <PrivateRouteRender path="/proyectos/festivos" component={gridTable} opcion='festivos'/> 
                                    {/* <PrivateRouteRender path="/maps"  component={HeatMap} />  */}
                                    {/*<PrivateRouteRender path="/profile" component={userProfile} />  */}
                                    <PrivateRouteRender path="/profile" component={userProfile} /> 
                                                                
                                </div>
                            </div>
                            <Route path="/login" component={LoginPage} /> 
                            <Route path="/logout" render={(props) => <LoginPage {...props} logout={true}/>} />
                            
                        </div>
                       
                </div>
                
            </div>
        </Router>
        )
    }
    //open newTab
    newTabClick() {
        let URL = window.location.href.replace(window.location.search, '');
        document.getElementById('newTab').setAttribute('href', URL.split('#')[0] + 'sidebar/sidebar-menu/index.html');
        console.log('en newTabClick')
    }
    //open the sidebar
    openClick() {
        this.sidebarobj.toggle();
        console.log('en openClick');
       
    }

    //close the sidebar when list item selected
    onSelect(args) {
        this.sidebarobj.hide();
        console.log('en onSelect');

    }

 
// Personalizar la presentacion de items del menú, se uso para cambiar el llamado <a> por <link> (args)
    menuTemplate = (args) => {
        var data = args.properties;
        const iconCss = "e-menu-icon "+data.iconCss+" icon";
        var caret;
        
        if (data.items && data.items.length > 0) {
            caret = <span className="e-icons e-caret"></span>
        }
        
        if (data.url.length > 0) {
            return (<Router history={history}>
                        <Link to={data.url}  className="e-menu-text e-menu-url">
                            <div className="e-anchor-wrap">
                                <span className={iconCss}></span> 
                                    {data.text}
                                {caret}
                            </div>
                        </Link>
                    </Router>);}
        return (<Router history={history}>
                    <div className="e-anchor-wrap">
                        <span className={iconCss}></span> 
                            {data.text}
                            {caret}
                    </div>
                </Router>);
      }
    
}